<div class="outline-comments">
    <div *ngIf="!hideButtonActionsForReviewer">
        <p class="outline-comments__info">{{'CONSENT.COMMENTS.MENU_DESCRIPTION_USER' | translate}}</p>
        <app-button
                [cssClasses]="'btn full-width solid__blue-07'"
                [icon]="'add'"
                [ariaLabel]="('CONSENT.COMMENTS.ADD_NEW_QUESTION' | translate) + ('GENERAL.BUTTON' | translate)"
                (buttonClicked)="addComment()">
            {{'CONSENT.COMMENTS.ADD_NEW_QUESTION' | translate}}
        </app-button>
    </div>
    <p class="outline-comments__info" *ngIf="hideButtonActionsForReviewer">
        {{'CONSENT.COMMENTS.MENU_DESCRIPTION_REVIEWER' | translate}}
    </p>
    <div class="outline-comments__box-holder" #commentHolderDiv (scroll)="onScroll()">
        <div class="outline-comments__box" *ngFor="let comment of comments">
            <app-comment
                    [sideMenuOpen]="sideMenuOpen"
                    [comment]="comment"
                    [disabled]="hideButtonActionsForReviewer"
                    (editEvent)="editComment($event)"
                    (deleteEvent)="deleteComment($event)">
            </app-comment>
        </div>
    </div>
</div>
